import React, { useEffect, useState } from 'react';
import { useAuth } from '../Context/AuthContext';
import RequestModal from '../Modals/DeletedItemsModal';
import { toast } from 'react-toastify';

import { Card, Container, Row, Col/*, Button, Form */} from 'react-bootstrap';

import { db } from '../firebase-config';
import { collection, query, getDocs, onSnapshot, where/*, orderBy, limit*/} from 'firebase/firestore';

import StatusSpinner from '../Components/StatusSpinner';

export default function EmployeeDeletedItems() {
    const { setShowSpinner, showSpinner } = useAuth();
    const [listOfWorkOrders, setListOfWorkOrders] = useState([]);
    const [chosenRequest, setChosenRequest] = useState({});
    const [currentWorkOrderHours, setCurrentWorkOrderHours] = useState([]);
    // const [currentHeading, setCurrentHeading] = useState('Last 10 Finalized Work Orders');
    const [modalShow, setModalShow] = useState(false);
    const [defaultTruckCharge, setDefaultTruckCharge] = useState("");
    const [defaultDailyRates, setDefaultDailyRates] = useState({Monday: "0", Tuesday: "0", Wednesday:"0", Thursday:"0", Friday:"0", Saturday:"0", Sunday:"0"});

    // const [where, setWhere] = useState("complete_timestamp");
    // const [whereOptions, setWhereOptions] = useState([]);
    // const [orderBy, setOrderBy] = useState("");
    // const [workOrderSearch, setWorkOrderSearch] = useState("");
    // const [limitSearch, setLimitSearch] = useState(10);

    useEffect(()=>{
        setShowSpinner(true);
        // const q = query(collection(db, "finalized_work_orders"), orderBy("complete_timestamp", "desc"), limit(10));
        const q = query(collection(db, "deleted_work_orders"));
        const unsubscribe =  onSnapshot(q, async (querySnapshot)=>{
            setShowSpinner(false);
            let tempListOfWorkOrders = [];
            querySnapshot.forEach((order)=>{
                tempListOfWorkOrders = [...tempListOfWorkOrders, {data: order.data(), id: order.id}];
            });
            tempListOfWorkOrders.sort((a,b) => {
                if(a.data.work_order.order_number > b.data.work_order.order_number) return 1;
                if(a.data.work_order.order_number < b.data.work_order.order_number) return -1;
                return 0;
            });
            setListOfWorkOrders(tempListOfWorkOrders);
        }, (error)=>{
            setShowSpinner(false);
            toast.error(`Failed to load data: ${error.message}`);
        });

        return ()=>{
            console.log("unsubscribe to snapshot");
            unsubscribe();
        }
    }, [setShowSpinner]);

    const loadHours = (requestID)=>{
        return new Promise(async (resolve, reject)=>{
          setShowSpinner(true);
          try{
            let hoursData = [];
            const q = query(collection(db, "hours"), where("requestID", "==", requestID));
            const querySnapshot = await getDocs(q);
            querySnapshot.forEach((doc)=>{
              hoursData = [...hoursData, doc.data()];
            });
            resolve(hoursData);
          }catch(error){
            reject(error.message);
          }
          setShowSpinner(false);
        });
    };
    const loadRates = ()=>{
        return new Promise(async (resolve, reject)=>{
            setShowSpinner(true);
            getDocs(collection(db, "rates")).then((snapShot)=>{
                let tempTruckCharge = "0";
                let tempDailyRates = {Monday: "0", Tuesday: "0", Wednesday:"0", Thursday:"0", Friday:"0", Saturday:"0", Sunday:"0"};
                snapShot.forEach((doc)=>{
                    if(doc.id === 'truck'){
                        tempTruckCharge = doc.data().rate;
                    }
                    if(doc.id === 'daily_tech_rates'){
                        tempDailyRates = doc.data();
                    }
                });
                return {truckCharge: tempTruckCharge, dailyRates: tempDailyRates};
            }).then((info)=>{
                setShowSpinner(false);
                setDefaultTruckCharge(info.truckCharge);
                setDefaultDailyRates(info.dailyRates);
                resolve('complete');
            }).catch((error)=>{
                setShowSpinner(false);
                toast.error(`Error getting rates list: ${error.message}`);
                reject(error.message);
            });
        });
    };

    return(
        <>
            <Container fluid style={{width:"100%", paddingLeft:"65px", marginRight:"65px"}}>
                <Container fluid className="mt-5" style={{fontSize:"1.5em", letterSpacing:"0.2em"}}>
                    <Row className="justify-content-center" style={{width:"100%"}}>
                        DELETED WORK ORDERS
                    </Row>
                </Container>
            </Container>
            <Container fluid className="mt-4" style={{width:"100%", paddingLeft:"70px", marginRight:"70px"}}>
                <Row>
                    <Col lg="12">
                        <Card style={{border:"1px solid black"}}>
                            <Card.Header style={{textAlign:"center"}}>Deleted Work Orders that can be Restored</Card.Header>
                            <Card.Body style={{textAlign:"left"}}>
                            {
                                listOfWorkOrders.map((workorder, index)=>{
                                    return(
                                        <div
                                            key={index}
                                            style={{cursor:"pointer", borderBottom:"1px solid lightgrey", paddingTop:20}}
                                            onClick={async ()=>{
                                                try{
                                                    let hoursData = await loadHours(workorder.id);
                                                    await loadRates(); 
                                                    setCurrentWorkOrderHours(hoursData);
                                                    setChosenRequest(workorder);
                                                    setModalShow(true);
                                                  }catch(error){
                                                    toast.error(`Failed to load hours: ${error}`);
                                                  }
                                            }}
                                        >
                                            {workorder.data.type.toUpperCase()}: {workorder?.data?.work_order?.service_at === undefined ? workorder.data.address : workorder.data.work_order.service_at} - {workorder?.data?.work_order?.order_number}
                                        </div>
                                    )
                                })
                            }
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>
            </Container>
            {
                showSpinner &&
                <StatusSpinner />
            }
            <RequestModal
                show={modalShow}
                onHide={(cancelBit, updateOrderButtonStatus)=> {
                    if(cancelBit === 'show cancel' && updateOrderButtonStatus === 'save'){
                        toast.warn(`Canceled: No changes were made to the work order.`);
                    }
                    setModalShow(false);
                }}
                request={chosenRequest}
                currentworkorderhours={currentWorkOrderHours}
                //setcurrentworkorderhours={setCurrentWorkOrderHours}
                defaultdailyrates={defaultDailyRates}
                defaulttruckcharge={defaultTruckCharge}
            />
        </>
    )
}